import { DotWrapper } from './styles'

interface IProps {
  color: string
}

const Dot = (props: IProps) =>
  <DotWrapper color={props.color} />

export default Dot
